import __request__ from 'routing/request';
type TableInfoArray = TableInfo[];
interface TableInfo {
    readonly name: string;
    readonly id: string;
}
/**
 * List available tables for a given Data Lake
 */
export function listTables(data_lake_id?: string): Promise<TableInfoArray> {
    return __request__('GET', `/plugins/org.graylog.plugins.datawarehouse/data_lake_tables/list_tables/${data_lake_id}`, null, {}, {
        'Accept': ['application/json']
    });
}
